'use client';

import type { TImageElement } from 'platejs';
import type { PlateElementProps } from 'platejs/react';

import { PlateElement } from 'platejs/react';

import { cn } from '@/lib/utils';

export function ImageElement(props: PlateElementProps<TImageElement>) {
  const { url, alt } = props.element;
  const src = typeof url === 'string' ? url : '';

  return (
    <PlateElement {...props} className="my-2">
      <figure className="m-0" contentEditable={false}>
        <img
          src={src}
          alt={typeof alt === 'string' ? alt : ''}
          className={cn('max-w-full rounded-md')}
        />
      </figure>
      {props.children}
    </PlateElement>
  );
}
